import { PromoCodeFormErrorJSON } from '../models/promo-code-form';

export const formPromoCodeErrors: PromoCodeFormErrorJSON = {
    promoCode: [
        {
            code: 'invalid',
            message: 'Promo code invalid, please try again',
        },
        {
            code: 'preventedHTMLStr',
            message: 'HTML tags or URLs are not allowed',
        },
    ],
};
